<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <nav-bar></nav-bar>
            <el-form
              ref="formselect"
              v-model="formselect"
              class="queryform_div"
              label-width="100px"
            >
              <el-row :gutter="24">
                <el-col :md="8" :xs="24" :sm="24">
                  <el-form-item :label="$t('desc.keyword')">
                    <el-input
                      size="small"
                      style="width: 100%"
                      v-model="formselect.name"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :md="6" :xs="24" :sm="24">
                  <el-form-item :label="$t('title.brandDisplay')">
                    <el-select
                      size="small"
                      v-model="formselect.brand"
                      disabled
                      :placeholder="$t('desc.select')"
                    >
                      <el-option key="" :label="$t('desc.select')" value="">
                      </el-option>
                      <el-option
                        v-for="item in brandList"
                        :key="item.brandCode"
                        :label="item.brandName"
                        :value="item.brandCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                  <el-button @click="getData('search')" type="primary" size="small"
                    >{{ $t("button.query") }}
                  </el-button>
                  <el-button @click="reset" size="small"
                    >{{ $t("button.reset") }}
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
            <template>
              <el-button
                v-if="hasCreateAuth"
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="add"
                style="margin-bottom: 10px"
                >{{ $t("button.add") }}
              </el-button>
              <div class="tableDiv">
                <el-table
                  :data="tableData1"
                  stripe
                  style="width: 100%"
                  v-loading="loading"
                  :empty-text="$t('desc.noData')"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="userName"
                    :label="$t('title.tenantAccount')"
                    min-width="150px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('title.accountName')"
                    min-width="100px"
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    prop="customerType"
                    :label="$t('title.accountType')"
                    min-width="100px"
                  >
                  </el-table-column> -->
                  <el-table-column
                    prop="brandCode"
                    :label="$t('title.brandDisplay')"
                    min-width="40px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="customerType"
                    :label="$t('title.accountType')"
                    min-width="100px"
                  >
                  <template slot-scope="scope">
                    {{ $t("desc." + scope.row.customerType) }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    prop="list"
                    min-width="300px"
                    :label="$t('desc.authList')"
                  >
                    <template slot-scope="scope">
                      <el-row :span="24">
                        <el-col 
                          v-for="item in scope.row.customerList"
                          v-if="scope.row.customerType == '客户'"
                          :md="24" :xs="24" :sm="24">
                          {{ item.customerCode }}_{{ item.customerName }}_{{
                            $t("desc."+item.companyType)
                          }}_{{ item.manageCpName }}
                        </el-col>
                        <el-col 
                          v-for="item in scope.row.relateList"
                          v-if="scope.row.customerType == '设备'"
                          :md="6" :xs="6" :sm="6">
                          {{ id2Display(scope.row.customerType, item) }}
                        </el-col>
                        <el-col 
                          v-for="item in scope.row.relateList"
                          v-if="scope.row.customerType == 'SE'"
                          :md="6" :xs="6" :sm="6">
                          {{ id2Display(scope.row.customerType, item) }}
                        </el-col>
                        <el-col 
                          v-for="item in scope.row.relateList"
                          v-if="scope.row.customerType == 'SSE'"
                          :md="6" :xs="6" :sm="6">
                          {{ id2Display(scope.row.customerType, item) }}
                        </el-col>
                        <el-col 
                          v-for="item in scope.row.relateList"
                          v-if="scope.row.customerType == '客户中心'"
                          :md="24" :xs="24" :sm="24">
                          {{ id2Display(scope.row.customerType, item) }}
                        </el-col>
                        <el-col 
                          v-for="item in scope.row.relateList"
                          v-if="scope.row.customerType == 'Dealer'"
                          :md="24" :xs="24" :sm="24">
                          {{ id2Display(scope.row.customerType, item) }}
                        </el-col>
                      </el-row>
                      <el-row :span="24">
                        <el-col
                          v-for="item in scope.row.customerList"
                          v-if="scope.row.customerType == '经销商'"
                          :md="24" :xs="24" :sm="24">
                          {{ item.agencyCode }}_{{ item.agencyName }}_{{
                            item.companyType
                          }}_{{ item.customerCenter }}
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.operate')"
                    width="150"
                    fixed="right"
                    v-if="hasResetPasswordAuth || hasDeleteAuth || hasUpdateAuth"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="hasResetPasswordAuth"
                        type="warning"
                        icon="el-icon-refresh"
                        :title="$t('title.resetPassword')"
                        circle
                        size="mini"
                        @click="resetPassw(scope.row)"
                      ></el-button>
                      <el-button
                        v-if="hasUpdateAuth"
                        type="primary"
                        icon="el-icon-edit"
                        :title="$t('button.update')"
                        circle
                        size="mini"
                        @click="edit(scope.row)"
                      ></el-button>
                      <template v-if="hasDeleteAuth">
                        <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('button.delete')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('title.confirmDelete')"
                          @confirm="delAccount(scope.row.id)"
                        >
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            :title="$t('button.delete')"
                            circle
                            size="mini"
                            slot="reference"
                          ></el-button>
                        </el-popconfirm>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  :page-sizes="[10, 20, 50]"
                  layout="prev, pager, next, sizes"
                  :total="pagination.totalPage"
                  :current-page.sync="pagination.current"
                  :page-size="pagination.pageSize"
                  @current-change="pageChange()"
                  @size-change="handleSizeChange"
                  style="text-align: center; margin-top: 10px"
                ></el-pagination>
              </div>
            </template>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>

    <el-dialog
      :title="dialogType == 'add' ? $t('button.add') : $t('button.update')"
      v-if="dialogAdd"
      :visible.sync="dialogAdd"
      width="60%"
      top="5vh"
    >
      <el-form ref="addform" :model="addform" label-width="200px" :rules="addRule">
        <el-form-item
          :label="$t('title.tenantAccount')"
          prop="userName"
          :rules="[{ required: true, message: $t('tips.needed') }]"
        >
          <el-input
            v-model="addform.userName"
            :disabled="dialogType != 'add'"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('title.accountName')"
          prop="name"
          :rules="[{ required: true, message: $t('tips.needed') }]"
        >
          <el-input
            v-model="addform.name"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('title.emailAddress')"
          prop="emailAddress"
          :rules="[{ required: true, message: $t('tips.needed') }]"
        >
          <el-input
            v-model="addform.emailAddress"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('title.brandDisplay')">
          <el-select
            size="small"
            v-model="addform.brand"
            disabled
            :placeholder="$t('desc.select')"
          >
            <el-option
              v-for="item in brandList"
              :key="item.brandCode"
              :label="item.brandName"
              :value="item.brandCode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="password" :label="$t('desc.password')" v-if="dialogType == 'add'">
          <el-input
            v-model="addform.password"
            style="width: 200px"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.accountType')">
          <el-select
            size="small"
            v-model="addform.customerType"
            :placeholder="$t('desc.select')"
            @change="changeAccountType"
          >
            <el-option :label="$t('desc.customer')" value="客户"></el-option>
            <el-option :label="$t('desc.equipment')" value="设备"></el-option>
            <el-option :label="$t('title.customerCenter')" value="客户中心"></el-option>
            <el-option :label="$t('desc.SE列表')" value="SE"></el-option>
            <el-option :label="$t('desc.SSE列表')" value="SSE"></el-option>
            <el-option :label="$t('desc.Dealer列表')" value="Dealer"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="customerIds"
          :rules="[{ required: true, message: $t('tips.needed') }]"
          :label="$t('desc.'+addform.customerType+'列表')"
        >
          <el-select
            v-if="addform.customerType == '客户'"
            v-model="addform.customerIds"
            filterable
            multiple
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteMethod"
            :loading="loading1"
            style="width: 100%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              
              v-for="(item, index) in custOptionsShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.id"
              :label="containTranslate(item.label)"
            >
              <span style="float: left; margin-right: 5px">{{
                containTranslate(item.label)
              }}</span>
            </el-option>
          </el-select>
          <el-select
            v-else-if="addform.customerType == '设备'"
            v-model="addform.customerIds"
            filterable
            multiple
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteDsnMethod"
            :loading="loading1"
            style="width: 100%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              
              v-for="(item, index) in dsnOptionShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            >
              <span style="float: left; margin-right: 5px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
          <el-cascader
            v-else-if="addform.customerType == '客户中心'"
            v-model="addform.customerIds"
            :options="centerOption"
            :props="{ multiple: true, checkStrictly: true, emitPath: false }"
            clearable
          ></el-cascader>
          <el-select
            v-else-if="addform.customerType == 'SE'"
            v-model="addform.customerIds"
            filterable
            multiple
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteSEMethod"
            :loading="loading1"
            style="width: 100%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              
              v-for="(item, index) in seOptionShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            >
              <span style="float: left; margin-right: 5px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
          <el-select
            v-else-if="addform.customerType == 'SSE'"
            v-model="addform.customerIds"
            filterable
            multiple
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteSSEMethod"
            :loading="loading1"
            style="width: 100%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              
              v-for="(item, index) in sseOptionShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            >
              <span style="float: left; margin-right: 5px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
          <el-select
            v-else-if="addform.customerType == 'Dealer'"
            v-model="addform.customerIds"
            filterable
            multiple
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteDealerMethod"
            :loading="loading1"
            style="width: 100%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              
              v-for="(item, index) in dealerOptionShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            >
              <span style="float: left; margin-right: 5px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onSubmit">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="dialogAdd = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$t('title.resetPassword')"
      v-if="dialogEditPass"
      :visible.sync="dialogEditPass"
      width="60%"
      top="5vh"
    >
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="200px"
      >
        <el-form-item :label="$t('title.tenantAccount')">
          <el-input
            style="width: 200px"
            :value="ruleForm.userName"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('tips.enterPwd')" prop="newPassword">
          <el-input
            v-model="ruleForm.newPassword"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('tips.enterAgain')" prop="pass2">
          <el-input
            v-model="ruleForm.pass2"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.managerPwd')" prop="adminPassword">
          <el-input
            v-model="ruleForm.adminPassword"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="resetPsw('ruleForm')">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="dialogEditPass = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  customerAccountCreate,
  customerAccountGetAll,
  customerAccountDelete,
  getAllCustomer,
  UpdateCustomer,
  ResetCoustomerPassword,
  getAgencys,
  resetPassword,
  getBrandInfos,
  sendEmail,
  authOperationCheck,
  GetAllDevice,
  getBrandCustomerRegionTree,
  GetCustomerRegions,
  getSEList,
  getSSEList,
  getDealerList
} from "../../api/api";

export default {
  name: "customerAccount",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("tips.enterAgain")));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error(this.$t("tips.twoPawNotSanme")));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      var yanzheng = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
        value
      );
      if (!yanzheng && value) {
        return callback(
          new Error(
              this.$t("tips.pwdTips")
          )
        );
      } else {
        callback();
      }
    };
    return {
      dialogAdd: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      dialogEditPass: false,
      loading: false,
      loading1: false,
      SkipCount: 0,
      dialogType: "",
      addRule:{
        password:[{ validator: validatePass1, trigger: "change" }],
      },
        
      rules: {
        newPassword: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
        adminPassword: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
        pass2: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
          { validator: checkName, trigger: "blur" },
        ],
      },
      formselect: {
        name: "",
        brand: localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR",
      },
      tableData1: [],
      addform: {
        id: "",
        name: "",
        brand: localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR",
        userName: "",
        customerType: "客户",
        password: "",
        emailAddress: "",
        customerIds: [],
      },
      custOptions: [],
      custOptionsShow: [],
      dsnOption: [],
      dsnOptionShow: [],
      centerOption:[],
      centerOptionShow: [],
      seOptionShow: [],
      sseOptionShow: [],
      dealerOptionShow: [],
      kehuList: [],
      customerList: [],
      selectPageSize: 30,
      ruleForm: {
        userId: "",
        name: "",
        newPassword: "",
        pass2: "",
        adminPassword: "",
      },
      brandList: [],
      custList: [],
      centerList:[],
      seList: [],
      sseList: [],
      dealerList: [],
      accountInfo: {},
      hasCreateAuth: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasResetPasswordAuth: false,
    };
  },
  watch: {
    'addform.customerType': {
      handler(newV, oldV) {
        if (newV == '客户中心') {
          this.$nextTick(()=>{
            //操作dom隐藏联级选择的第一层勾选框
            let dom = document.getElementsByClassName("el-cascader-node__label");
            for (let index = 0; index < dom.length; index++) {
              const element = dom[index];
              if (element.innerText == "PAC"||element.innerText == "BV"||element.innerText == "Rotary") {
                element.parentNode.firstChild.style.display = 'none'
              }
            }
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.authoperation("CustomerAccount");
    this.getBrandInfos();
    this.getData();
    this.getCustomerAll();
    this.getAllDevice();
    this.getSEList();
    this.getSSEList();
    this.getDealerList();
    this.getBrandCustomerRegionTree();
    this.GetCustomerRegions();
  },
  methods: {
    authoperation(curPage) {
      let that = this;
      let res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasResetPasswordAuth = res.hasResetPasswordAuth;
    },
    async GetCustomerRegions(){
      let res = await GetCustomerRegions();
      this.centerList = res.result;
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      that.brandList = res.result;
    },
    async getSEList() {
      let that = this;
      let res = await getSEList();
      that.seList = res.result.map((item) => {
        return {
          id: `${item.emailAddress}`,
          label: `${item.name}`,
        };
      });
      that.seOptionShow = JSON.parse(JSON.stringify(that.seList));
    },
    async getSSEList() {
      let that = this;
      let res = await getSSEList();
      that.sseList = res.result.map((item) => {
        return {
          id: `${item.emailAddress}`,
          label: `${item.name}`,
        };
      });
      that.sseOptionShow = JSON.parse(JSON.stringify(that.sseList));
    },
    async getDealerList() {
      let that = this;
      let res = await getDealerList();
      that.dealerList = res.result.map((item) => {
        return {
          id: `${item.dealerId}`,
          label: `${item.name}`,
        };
      });
      that.dealerOptionShow = JSON.parse(JSON.stringify(that.dealerList));
    },
    changeAccountType(){
      let that = this;
      if (that.accountInfo.customerType == that.addform.customerType) {
        let customerIds = that.accountInfo.relateList;
        that.$set(that.addform, "customerIds", customerIds);
      } else {
        that.$set(that.addform, "customerIds", []);
      }
    },
    //分页
    pageChange() {
      this.getData();
    },
    //设置默认密码
    makePassword(lenth) {
      var str = new Array();
      str[0] = "abcdefghijklmnopqrstuvwxyz";
      str[1] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      str[2] = "0123456789";
      var result = "";
      var time0 = 0;
      var time1 = 0;
      var time2 = 0;
      for (let index = 0; index < lenth; index++) {
        let strCount = Math.floor(Math.random() * 3); //获取0-3的随机数
        if (strCount == 0) {
          time0++;
          if (time0 >= lenth / 3 + 1) {
            strCount = 1;
            if (time1 >= lenth / 3 + 1) {
              strCount = 2;
            }
          }
        }
        if (strCount == 1) {
          time1++;
          if (time1 >= lenth / 3 + 1) {
            strCount = 2;
            if (time2 >= lenth / 3 + 1) {
              strCount = 0;
            }
          }
        }
        if (strCount == 2) {
          time2++;
          if (time2 >= lenth / 3 + 1) {
            strCount = 0;
            if (time0 >= lenth / 3 + 1) {
              strCount = 1;
            }
          }
        }
        var aaa = Math.floor(Math.random() * str[strCount].length);
        result += str[strCount][aaa];
      }
      return result;
    },
    getCustomerAll() {
      var that = this;
      getAllCustomer().then((res) => {
        if (res.success) {
          that.customerList = res.result;
          
          that.custOptions = that.customerList.map((item) => {
            return {
              id: `${item.id}`,
              label: `${
                item.customerCode +
                "_" +
                item.customerName +
                "_" +
                item.companyType +
                "_" +
                item.manageCpName
              }`,
            };
          });
          this.custOptionsShow = JSON.parse(JSON.stringify(this.custOptions))
        }
      });
    },
    open(e, result, type) {
      let title = this.$t("title.resetPassword");
      if (type == "create") {
        title = this.$t("opeateType.create")
      }
      const h = this.$createElement;
      this.$msgbox({
        title: title,
        message: h('p', null, [
          h('span', null, this.$t("title.newPassword") + "：" + result),
        ]),
        showCancelButton: false,
        showConfirmButton:true,
        confirmButtonText: this.$t("button.sendEmail"),
        cancelButtonText: this.$t("button.confirm"),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            // instance.confirmButtonText = '执行中...';
            setTimeout(() => {
              this.sendMail(e, result, type).then(()=>{
                done();
                instance.confirmButtonLoading = false;
              })
            }, 300);
          } else {
            done();
            if (type == "create") {
              this.dialogAdd = false;
              this.getData();
            }
          }
        }
      }).then((action, instance, done) => {
        // this.sendMail(e, result, type);
        // done();
      });
    },
    async getAllDevice(){
      let that = this;
      let res = await GetAllDevice();
      that.dsnOption = res.result.map((item) => {
        return {
          id: `${item.id}`,
          label: `${item.dsn}`,
        };
      });
      this.dsnOptionShow = JSON.parse(JSON.stringify(this.dsnOption));
    },
    async getBrandCustomerRegionTree(){
      let res = await getBrandCustomerRegionTree();
      this.centerOption = res.result;
      this.centerOptionShow = JSON.parse(JSON.stringify(this.centerOption));
    },
    resetPassw(e) {
      var that = this;
      this.ruleForm.userId = e.id;
      this.ruleForm.name = e.name;
      this.ruleForm.userName = e.userName;
      this.ruleForm.newPassword = "";
      this.ruleForm.pass2 = "";
      this.ruleForm.adminPassword = "";
      this.$prompt(this.$t("desc.enterAdminPwd"), this.$t("title.tips"), {
        confirmButtonText: this.$t("button.confirm"),
        cancelButtonText: this.$t("button.cancel"),
        inputType: "password",
        inputPattern: /\S/,
        inputErrorMessage: this.$t("desc.enterAdminPwd"),
      })
        .then(({ value }) => {
          let data = { AdminPassword: value, UserId: e.id };
          resetPassword(data)
            .then((res) => {
              this.open(e.emailAddress, res.result, "reset");
            })
            .catch((err) => {
              that.$message({
                showClose: true,
                message: err.error.message,
                type: "error",
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入",
          // });
        });
    },
    async sendMail(e, psw, type){
      let that = this;
      let postData = {
        userEmail: e,
        psw: psw,
        type: type,
        url: window.location.origin
      };
      try {
        let res = await sendEmail(postData);
        this.$message.success(this.$t("tips.mailSendingSuccessfully"));
        if (type == "create") {
          that.dialogAdd = false;
          that.getData();
        }
      } catch (error) {
        this.$message.error(this.$t("tips.mailSendingFailed"));
      }
      
    },
    loadMore(n) {
      return () => (this.selectPageSize += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.custOptionsShow = this.custOptions.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.custOptionsShow = this.custOptions;
      }
    },
    remoteDsnMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.dsnOptionShow = this.dsnOption.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.dsnOptionShow = this.dsnOption;
      }
    },
    remoteSEMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.seOptionShow = this.seList.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.seOptionShow = this.seList;
      }
    },
    remoteSSEMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.sseOptionShow = this.sseList.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.sseOptionShow = this.sseList;
      }
    },
    remoteDealerMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.dealerOptionShow = this.dealerList.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.dealerOptionShow = this.dealerList;
      }
    },
    delAccount(e) {
      customerAccountDelete(e).then((res) => {
        if (res.success) {
          this.$message.success(this.$t("tips.deleteSuccess"));
          this.getData();
        }
      });
    },
    add() {
      this.dialogAdd = true;
      this.selectPageSize = 30;
      this.dialogType = "add";
      this.addform = {
        name: "",
        customerType: "客户",
        brand: localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR",
        emailAddress: "",
        password: "",
        customerIds: [],
      };
      this.addform.password = this.makePassword(8);
    },
    edit(e) {
      let that =this;
      that.accountInfo = e;
      this.selectPageSize = 30;
      // this.dsnOptionShow = [];
      that.dialogType = "edit";
      that.dialogAdd = true;
      that.options = new Array();
      if (e.customerType == "客户") {
        that.custOptionsShow = [];
        let customerIds1 = e.customerList.map((item) => {
          return {
            id: `${item.id}`,
            label: `${
              item.customerCode +
              "_" +
              item.customerName +
              "_" +
              item.companyType +
              "_" +
              item.manageCpName
            }`,
          };
        });
        //把数据库的数据显示在下拉框前列
        that.custOptionsShow.push(...customerIds1);
        //去除重复的
        let idList = that.custOptionsShow.map(item=> item.id);
        let custArr = that.custOptions.filter(x=>!idList.includes(x.id))
        that.custOptionsShow.push(...custArr)
      }else if (e.customerType == "设备") {
        that.dsnOptionShow = [];
        let relate1 = that.dsnOption.filter(x=>e.relateList.includes(x.id));
        that.selectPageSize = relate1.length > 30? relate1.length : 30;
        that.dsnOptionShow.push(...relate1)
        let relateArr = that.dsnOption.filter(x=>!e.relateList.includes(x.id))
        that.dsnOptionShow.push(...relateArr)
      }else if (e.customerType == "SE") {
        that.seOptionShow = [];
        let relate1 = that.seList.filter(x=>e.relateList.includes(x.id));
        that.selectPageSize = relate1.length > 30? relate1.length : 30;
        that.seOptionShow.push(...relate1)
        let relateArr = that.seList.filter(x=>!e.relateList.includes(x.id))
        that.seOptionShow.push(...relateArr)
      }else if (e.customerType == "SSE") {
        that.sseOptionShow = [];
        let relate1 = that.sseList.filter(x=>e.relateList.includes(x.id));
        that.selectPageSize = relate1.length > 30? relate1.length : 30;
        that.sseOptionShow.push(...relate1)
        let relateArr = that.sseList.filter(x=>!e.relateList.includes(x.id))
        that.sseOptionShow.push(...relateArr)
      }else if (e.customerType == "Dealer") {
        that.dealerOptionShow = [];
        let relate1 = that.dealerList.filter(x=>e.relateList.includes(x.id));
        that.selectPageSize = relate1.length > 30? relate1.length : 30;
        that.dealerOptionShow.push(...relate1)
        let relateArr = that.dealerList.filter(x=>!e.relateList.includes(x.id))
        that.dealerOptionShow.push(...relateArr)
      }
      
      let customerIds = e.relateList;
      that.$set(that.addform, "customerIds", customerIds);
      that.addform.id = e.id;
      that.addform.name = e.name;
      that.addform.userName = e.userName;
      that.addform.customerType = e.customerType;
      that.addform.brand = e.brandCode;
      that.addform.password = e.password;
      that.addform.emailAddress = e.emailAddress;
    },
    reset() {
      this.formselect.name = "";
      //this.formselect.brand = "";
      this.getData('search');
    },
    getData(type = "normal") {
      this.loading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      var data = {
          Keyword: this.formselect.name,
          Brand: this.formselect.brand,
          skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
          maxResultCount: this.pagination.pageSize
        },
        that = this;
      customerAccountGetAll(data).then((res) => {
        if (res.success) {
          that.tableData1 = res.result.items;
          this.pagination.totalPage = res.result.totalCount;
          this.loading = false;
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    resetPsw(ruleForm) {
      let that = this;
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          var data = this.ruleForm;
          ResetCoustomerPassword(data)
            .then((res) => {
              if (res.success) {
                this.$message.success(that.$t("tips.oprationSuccess"));
                this.getData();
                this.dialogEditPass = false;
              } else {
                this.$message.error(res.error.message);
              }
            })
            .catch((err) => {
              this.$message.error(err.error.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit() {
      this.addform.userName=this.trimStr(this.addform.userName);
      this.addform.name = this.trimStr(this.addform.name);
      this.addform.emailAddress=this.trimStr(this.addform.emailAddress);
      var data = this.addform,
        that = this;
      this.$refs["addform"].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            if (!this.addform.password) {
              this.$message.warning(this.$t("tips.enterPwd"));
              return;
            }
            delete data.id;
          }
          var reg =
            /^[A-Za-z0-9\-]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
          if (!reg.test(this.addform.emailAddress)) {
            this.$message.warning(this.$t("tips.enterCorrectEmail"));
            return;
          }
          data.surName = this.addform.name;
          data.brandCode = this.addform.brand;
          if (this.dialogType == "add") {
            customerAccountCreate(data)
              .then((res) => {
                if (res.success) {
                  this.open(this.addform.emailAddress, this.addform.password, "create");
                  // that.dialogAdd = false;
                  // that.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          } else {
            UpdateCustomer(data)
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t("tips.updateSuccess"));
                  that.dialogAdd = false;
                  that.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    trimStr(str){
      str=(str === undefined ? "" : str);
      return str.replace(/(^\s*)|(\s*$)/g,"");
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他', '直销'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    },
    id2Display(type, id){
      if (type == "设备") {
        return this.dsnOption.find(a=> a.id ==id)?.label
      } else if (type == "客户中心") {
        const curCenter = this.centerList.find(a=> a.id ==id)
        if (curCenter.regionType == "Other") {
          curCenter.regionType = "Rotary"
        }
        return curCenter.regionType + '/' + curCenter.regionName
      } else if (type == "SE") {
        return this.seList.find(a=> a.id ==id)?.label
      } else if (type == "SSE") {
        return this.sseList.find(a=> a.id ==id)?.label
      }else if (type == "Dealer") {
        return this.dealerList.find(a=> a.id ==id)?.label
      }
    }
  },
  //自定义指令-实现下拉框滚动翻页
  directives: {
    "el-select-loadmore": (el, binding) => {
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition =
            this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    },
  },
};
</script>


